import { UserSettings } from 'src/types/UserSettings.ts';
import { getPriceValue } from 'src/modules/checkout/getPriceValue.ts';
import { sortAccessories } from 'src/modules/common/utils/sortAccessories.ts';
import { SensorsAccessoriesPageData } from 'src/sensors/accessories/SensorsAccessoriesPageMapping.ts';
import { LocationState } from 'src/sensors/LocationState.ts';

export const calculateTotals = (
    {
        sensor,
        accessories: sensorAccessories,
    }: SensorsAccessoriesPageData['accessories'],
    userSettings: UserSettings,
    checkoutState: LocationState,
    currency: string | null,
): {
    subtotal: number;
    accessoriesSubtotal: number;
    total: number;
    currentCurrency: string;
    accessories: SensorsAccessoriesPageData['accessories']['accessories'];
    pricePerUnit: number;
} => {
    const sensorPrice = getPriceValue(sensor, userSettings.shoppingCenter as keyof typeof sensor, currency);
    const currentCurrency = sensorPrice?.currency || currency || 'USD';
    const pricePerUnit = sensorPrice ? sensorPrice.value : 0;
    const subtotal = pricePerUnit * checkoutState.qty;

    const accessories = [
        ...sensorAccessories,
    ].reduce((acc, curr) => {
        const exist = acc.find((item) => item.item.Label === curr.item.Label);
        if (!exist && checkoutState.selectedAccessories.find(({ label }) => label === curr.item.Label) !== undefined) {
            acc.push(curr);
        }
        return acc;
    }, [] as SensorsAccessoriesPageData['accessories']['accessories'])
        .sort(sortAccessories);

    const accessoriesSubtotal = accessories
        .reduce((acc, { item }) => {
            const price = getPriceValue(item, userSettings.shoppingCenter as keyof typeof item, currency);
            if (!price) {
                return acc;
            }
            const accessoryItem = checkoutState.selectedAccessories.find(({ label }) => label === item.Label);
            const qty = accessoryItem ? accessoryItem.qty : 1;
            return acc + (price.value * qty);
        }, 0);

    const total = subtotal + accessoriesSubtotal;

    return {
        subtotal,
        accessoriesSubtotal,
        total,
        currentCurrency,
        accessories,
        pricePerUnit,
    };
};
